import { FC, useCallback, useEffect, useState } from 'react';
import { getOnFarmSpecimenLocations } from '../../../../api/onFarmSpecimenLocationApi';
import { showToast } from '../../../../services/toast.service';
import { OnFarmSpecimenLocation } from '../../../../types/interfaces/onFarmSpecimen.interfaces';
import { LABEL_CONSTANTS } from '../../../../constants/common';
import { toastMessages } from '../../../../constants/errorMessages';
import '../../../inventory-management/list-storage-locations/listStorageLocations.scss';

const LabeledValue: FC<{ label: string; value?: string }> = ({ label, value }) => {
  return (
    <div className="labeled-value-info">
      <label>
        {label} <span>{value ?? ''}</span>
      </label>
    </div>
  );
};

const Row: FC<{ location: OnFarmSpecimenLocation }> = ({ location }) => {
  const canister = location.accountStorageCanister;
  const tank = canister?.accountStorageTank;
  const site = tank?.accountStorageSite;

  return (
    <div className="location-row card">
      <LabeledValue label={`${LABEL_CONSTANTS.SITE} :`} value={site?.name} />
      <LabeledValue label={`${LABEL_CONSTANTS.TANK} :`} value={tank?.name} />
      <LabeledValue label={`${LABEL_CONSTANTS.CANISTER} :`} value={canister?.name} />
      <LabeledValue label={`${LABEL_CONSTANTS.QUANTITY} :`} value={String(location.quantity)} />
    </div>
  );
};

const ListOnFarmStorageLocations: FC<{ onFarmSpecimenId: number | string }> = ({ onFarmSpecimenId }) => {
  const [locations, setLocations] = useState<OnFarmSpecimenLocation[]>();

  const handleGetLocations = useCallback(async () => {
    try {
      const { data: specimenLocations } = await getOnFarmSpecimenLocations({
        include: 'AccountStorageCanister.AccountStorageTank.AccountStorageSite',
        filter: `OnFarmSpecimenId eq ${onFarmSpecimenId}`,
      });
      setLocations(specimenLocations);
    } catch {
      showToast.error(toastMessages.SOMETHING_WENT_WRONG);
    }
  }, [onFarmSpecimenId]);

  useEffect(() => {
    handleGetLocations();
  }, [handleGetLocations]);

  return (
    <div className="list-storage-locations">
      {locations && locations.length > 0 ? (
        locations.map((location: OnFarmSpecimenLocation) => {
          const key = location.onFarmSpecimenLocationId ?? location.accountStorageCanisterId;

          return (
            <div key={`onfarm-storage-location-${key}`}>
              <div className="desk-list-storage-locations">
                <Row location={location} />
              </div>

              <div className="xs-list-storage-locations">
                <div className="card">
                  <div className="list-storage-location">
                    <div className="storage-location-content">
                      <div className="location-content">
                        <label>{`${LABEL_CONSTANTS.SITE} : ${location.accountStorageCanister?.accountStorageTank?.accountStorageSite?.name}`}</label>
                      </div>
                      <div className="location-content">
                        <label>{`${LABEL_CONSTANTS.TANK} : ${location.accountStorageCanister?.accountStorageTank?.name}`}</label>
                      </div>
                    </div>
                    <div className="storage-location-content">
                      <div className="location-content">
                        <label>{`${LABEL_CONSTANTS.CANISTER} : ${location.accountStorageCanister?.name}`}</label>
                      </div>
                      <div className="location-content">
                        <label>{`${LABEL_CONSTANTS.QUANTITY} : ${String(location.quantity)}`}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="no-locations">{LABEL_CONSTANTS.NO_LOCATION_FOUND}</div>
      )}
    </div>
  );
};

export default ListOnFarmStorageLocations;
